import { FC, useEffect } from 'react'
import { ErrorViewer } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useSidebarLayers } from '@/features/layout/hooks/useSidebarLayers'

export const CourseUnavailable: FC = () => {
  const { t } = useTranslation()

  const { setLayers } = useSidebarLayers()

  useEffect(() => {
    setLayers(null)
  }, [setLayers])

  return (
    <ErrorViewer
      code={404}
      title={t('courseDetails.unavailableCourse')}
      text={t('courseDetails.courseNotExist')}
      buttonText={t('pageError.redirectTextLearner')}
      fallbackUrl="/courses"
    />
  )
}
